/**
 * registerOpenAlgoIndicators.js
 * Registers custom indicators into openalgo-charts 1.8.2 runtime engine.
 * Implements "ADX DI Blue Bars" first-class indicator with native barColors.
 */

import { registerIndicator } from 'openalgo-charts';
import { calculateAdxDiBlueBars } from './adxDiBlueBars';

export const adxDiBlueBarsDescriptor = {
    id: 'adx_di_blue_bars',
    name: 'ADX DI Blue Bars',
    category: 'Trend',
    placement: 'pane',
    inputs: [
        { key: 'diPeriod', type: 'number', label: 'DI Length', default: 14, min: 1, max: 500, step: 1 },
        { key: 'adxPeriod', type: 'number', label: 'ADX Smoothing', default: 14, min: 1, max: 500, step: 1 },
        { key: 'adxMaPeriod', type: 'number', label: 'ADX MA Length', default: 2, min: 1, max: 50, step: 1 },
        { key: 'channelPeriod', type: 'number', label: 'Donchian Length', default: 20, min: 1, max: 500, step: 1 },
        { key: 'adxColor', type: 'color', label: 'ADX', default: '#A855F7' },
        { key: 'adxMaColor', type: 'color', label: 'ADXMA', default: '#F97316' },
        { key: 'plusColor', type: 'color', label: '+DI', default: '#10B981' },
        { key: 'minusColor', type: 'color', label: '-DI', default: '#EF4444' },
    ],
    plots: [
        { key: 'adx', type: 'line', title: 'ADX', colorKey: 'adxColor', style: { lineWidth: 2 } },
        { key: 'adxma', type: 'line', title: 'ADXMA', colorKey: 'adxMaColor', style: { lineWidth: 1.5 } },
        { key: 'plusDi', type: 'line', title: '+DI', colorKey: 'plusColor', style: { lineWidth: 1.5 } },
        { key: 'minusDi', type: 'line', title: '-DI', colorKey: 'minusColor', style: { lineWidth: 1.5 } },
    ],
    calc: (bars, settings) => {
        const enriched = calculateAdxDiBlueBars(bars, {
            diPeriod: settings.diPeriod || 14,
            adxPeriod: settings.adxPeriod || 14,
            adxMaPeriod: settings.adxMaPeriod || 2,
            channelPeriod: settings.channelPeriod || 20,
        });

        return {
            adx: enriched.map(c => c.ADX),
            adxma: enriched.map(c => c.ADXMA),
            plusDi: enriched.map(c => c.PDI),
            minusDi: enriched.map(c => c.MDI),
            blue_bar: enriched.map(c => c.blue_bar),
        };
    },
    barColors: ({ bars, values }) => {
        const blueFlags = values.blue_bar || [];
        return bars.map((bar, i) => (blueFlags[i] === 1 ? '#3B82F6' : null));
    }
};

// Register indicator into openalgo-charts runtime
export function initOpenAlgoIndicators() {
    try {
        registerIndicator(adxDiBlueBarsDescriptor);
    } catch (e) {
        console.warn('Could not register adx_di_blue_bars indicator in openalgo-charts:', e);
    }
}

// Auto-register on import
initOpenAlgoIndicators();
